// Known ad-server sources a streaming mapping can come from. Keep in sync with
// com.blisspointmedia.streaming.MappingEntry.Source in the blisspointmedia Java repo.
export const AdServerSource = {
  TTD: 'TTD',
  WMT: 'WMT',
  FLASHTALKING: 'FLASHTALKING',
  AMAZON: 'AMAZON',
  NETFLIX: 'NETFLIX',
  NEXXEN: 'NEXXEN',
  SAM: 'SAM',
  TMOBILE: 'TMOBILE'
} as const;
export type AdServerSourceType = (typeof AdServerSource)[keyof typeof AdServerSource];

const VALID_AD_SERVER_SOURCES = new Set<string>(Object.values(AdServerSource));

// Normalizes a raw source string (from a CSV column or an unresolved-mapping entry) into the
// lowercase ad_server value streaming_placements expects, or null if it isn't a recognized source.
export const normalizeAdServer = (rawSource: string): string | null => {
  const source = rawSource.trim().toUpperCase();
  if (!VALID_AD_SERVER_SOURCES.has(source)) {
    return null;
  }
  if (source === AdServerSource.FLASHTALKING) return 'ft';
  return source.toLowerCase();
};
